import { getExtensionFromUrl } from './url';

/**
 * Returns true if the given URL is an SVG.
 *
 * @param url - a URL to check
 * @returns true if the URL is an SVG, false otherwise
 */
export function isSvg(url: string): boolean {
  return getExtensionFromUrl(url) === 'svg';
}
